export enum TimeZone {
	Europe_Berlin = 'Europe/Berlin',
	Europe_Rome = 'Europe/Rome',
	Europe_Lisbon = 'Europe/Lisbon',
	Europe_Madrid = 'Europe/Madrid',
	Europe_Paris = 'Europe/Paris',
	Europe_Sofia = 'Europe/Sofia',
	Europe_Warsaw = 'Europe/Warsaw',
	Europe_Prague = 'Europe/Prague',
	Europe_Budapest = 'Europe/Budapest',
	Europe_Athens = 'Europe/Athens',
	Europe_Helsinki = 'Europe/Helsinki',
	Europe_Stockholm = 'Europe/Stockholm',
	Europe_Copenhagen = 'Europe/Copenhagen',
	Europe_Belgrade = 'Europe/Belgrade',
	Europe_Tirane = 'Europe/Tirane',
	Europe_Istanbul = 'Europe/Istanbul',
	Europe_Moscow = 'Europe/Moscow',
	Asia_Tokyo = 'Asia/Tokyo',
	Asia_Seoul = 'Asia/Seoul',
	Asia_Shanghai = 'Asia/Shanghai',
	Asia_Hong_Kong = 'Asia/Hong_Kong',
	Asia_Jerusalem = 'Asia/Jerusalem',
	Asia_Jakarta = 'Asia/Jakarta',
}
